import { TranslationNamespaceBackend } from '@cas/utils/translationHelpers';
import { InterpolatedMessageModel } from '@customer/store/apis/commonModels';
import { Trans } from 'react-i18next';

export interface InterpolatedMessageProps {
  interpolatedMessage: InterpolatedMessageModel;
}

export const InterpolatedMessage = ({ interpolatedMessage }: InterpolatedMessageProps) => {
  return (
    <Trans
      i18nKey={interpolatedMessage.m}
      ns={TranslationNamespaceBackend}
      values={interpolatedMessage.a}
    />
  );
};

export default InterpolatedMessage;
